import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import InspectorListComponent from '@/components/SchedulePage/Timeline/InspectorList/InspectorListComponent';
import { getScheduledOrderCredits } from '@/components/SchedulePage/helpers/credits';

const InspectorListContainer = ({ busy }) => {
  const inspectors = useSelector(({ schedule }) => schedule.filteredInspectors);
  const orders = useSelector(({ schedule }) => schedule.orders);
  const scheduledCreditsByInspector = useMemo(
    () =>
      orders.reduce((creditsByInspector, scheduledOrder) => {
        const inspectorId = scheduledOrder?.schedule?.who?.inspector_id;

        if (inspectorId) {
          creditsByInspector[inspectorId] =
            (creditsByInspector[inspectorId] || 0) + getScheduledOrderCredits(scheduledOrder);
        }

        return creditsByInspector;
      }, {}),
    [orders]
  );

  return (
    <InspectorListComponent
      busy={busy}
      inspectors={inspectors}
      scheduledCreditsByInspector={scheduledCreditsByInspector}
    />
  );
};

InspectorListContainer.propTypes = {
  busy: PropTypes.bool.isRequired,
};

export default InspectorListContainer;
